import { render, staticRenderFns } from "./OrderFinishBuy.vue?vue&type=template&id=0701fd67&scoped=true&"
import script from "./OrderFinishBuy.vue?vue&type=script&lang=js&"
export * from "./OrderFinishBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0701fd67",
  null
  
)

export default component.exports